import { createApiCall, MethodType, URI } from "../Api";
import { PatientsPayload } from "models/patients/patientList";
import { IDeletePatientPayload } from "models/patients/deletePatient";
import { ISubscribeSuperCityPayload } from "models/patients/subscribeSuperCity";

export const getPatients = (payload: PatientsPayload) => {
  return createApiCall(MethodType.GET, URI.PATIENTS.PATIENTS_LIST, payload);
};

export const downloadPatientsCSV = (payload: PatientsPayload) => {
  return createApiCall(
    MethodType.GET,
    URI.PATIENTS.DOWNLOAD_PATIENTS_CSV,
    payload
  );
};

export const deletePatient = (payload: IDeletePatientPayload) => {
  return createApiCall(MethodType.DELETE, URI.PATIENTS.DELETE_PATIENT, payload);
};
export const subcribePatient = (payload: ISubscribeSuperCityPayload) => {
  return createApiCall(
    MethodType.POST,
    URI.PATIENTS.SUBSCRIBE_SUPER_CITY(payload.patient_ids)
  );
};
